import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map, Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {CollectionModel} from "../models/collection.model";

@Injectable({
  providedIn: 'root'
})
export class CollectionsService {
  constructor(
    private http: HttpClient
  ) {
  }

  getCollectionById(collectionId: string): Observable<any> {
    return this.http.get<CollectionModel[]>(`${environment.apiURL}/collections/collection/${collectionId}`);
  }

  getCollections(): Observable<any> {
    return this.http.get<CollectionModel[]>(`${environment.apiURL}/collections`).pipe(
      map(collections => collections.sort((a, b) => a.title.localeCompare(b.title))) // Sort by title A-Z
    );
  }
}
